import React from 'react';
import utilFunction from '../../containers/function';
import BarChart from '../common/graphs/crossfilterGraphs/barChart';

const AvgDurationByArriveTimeGraph = props => {
  return (
    <div id="avg-duration-by-arrive-time-graph" className="dc-chart-parent">
      <BarChart
        id={'avg-duration-by-arrive-time-graph-component'}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={true}
        dimension={{
          formatFunction: [],
          name: 'hour',
          originalName: 'hour',
          reduceFunction: { type: 'CONTINUOUS_GROUP', typeof: 'NUMBER' }
        }}
        metrics={[
          {
            config: {},
            filter: [],
            formatFunction: [],
            metric: 'avgWaitingTime',
            name: 'Total',
            reduceFunction: { type: 'AVG' },
            type: 'AVG'
          }
        ]}
        config={{
          legend: false,
          tooltip: {
            valuesConfig: [
              {
                identifier: 'layer',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div style='text-align:left'>${
                  props.tooltip.proccess
                }: <span style='font-weight: bold;'>%v</span></div>`
              },
              {
                identifier: 'x',
                valueFormat: { type: 'NUMBER', format: 'hh:mm' },
                wrapper: `<div style='text-align:left'>${
                  props.tooltip.comingTime
                }: <span style='font-weight:bold;'>%v</span></div>`
              },
              {
                identifier: 'y',
                valueFormat: { type: 'NUMBER', format: 'hh:mm', factor: 60, factorOperator: '/' },
                wrapper: `<div style='text-align:left'>${
                  props.tooltip.averageDuration
                }: <span style='font-weight:bold;'>%v</span></div>`
              }
            ]
          },
          horizontal: false,
          gap: 5,
          colors: ['#5192DC', '#6AB386', '#EE9152', '#E6485A'],
          xAxis: {
            rotation: 0,
            label: props.tooltip.arrivalTime,
            interval: 1,
            autoRange: { active: false, max: 23, min: 0 }
          },
          yAxis: {
            padding: 65,
            labelPadding: 70,
            label: 'Duración',
            show: true,
            ticksNumber: 4,
            format: 'hh:mm',
            factor: 60,
            factorOperator: "/",
          }
        }}
        dashboardId={'detail_waiting_times'}
      />
    </div>
  )
};

export default AvgDurationByArriveTimeGraph;



// WEBPACK FOOTER //
// ./source/client/components/detail_waiting_times/avgDurationByArriveTimeGraph.jsx